import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { logSuccess, logError } from '../toaster'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

export const updateSensitiveDataPolicyMutation = gql`
  mutation UpdateSensitiveDataPolicy(
    $organizationID: ID!
    $policyID: ID!
    $rules: [UpdateSensitiveDataPolicyRuleArg]!
  ) {
    updateSensitiveDataPolicy(
      input: {
        organizationID: $organizationID
        policyID: $policyID
        rules: $rules
      }
    ) {
      _placeholder
    }
  }
`

export interface UpdateSensitiveDataPolicyArgs {
  readonly organizationID: string
  readonly policyID: string
  readonly rules: Array<{
    readonly keywords: string[]
  }>
}

export function UpdateSensitiveDataPolicyMutation({
  children
}: {
  readonly children: (
    updateSensitiveDataPolicy: (
      variables: UpdateSensitiveDataPolicyArgs
    ) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, UpdateSensitiveDataPolicyArgs>
      mutation={updateSensitiveDataPolicyMutation}
    >
      {(updateSensitiveDataPolicy) => {
        return (
          <ContrastFormattedMessage id="detail_sensitiveData_saveSuccessMessage">
            {(saveSuccessMsg) => {
              return (
                <ContrastFormattedMessage id="detail_sensitiveData_saveErrorMessage">
                  {(saveErrorMessage) => {
                    return children(
                      async (variables: UpdateSensitiveDataPolicyArgs) => {
                        try {
                          await updateSensitiveDataPolicy({ variables })
                          logSuccess(saveSuccessMsg)
                        } catch (err) {
                          logError(saveErrorMessage)
                        }
                      }
                    )
                  }}
                </ContrastFormattedMessage>
              )
            }}
          </ContrastFormattedMessage>
        )
      }}
    </Mutation>
  )
}
